export default "__VITE_ASSET__68$Acw31__"